var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('proposal-provider',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var proposal = ref.proposal;
var campaign = ref.campaign;
var contact = ref.contact;
var campaignFields = ref.campaignFields;
var isLoading = ref.isLoading;
var proposalSteps = ref.proposalSteps;
var currentProposalStep = ref.currentProposalStep;
var isProposalPreview = ref.isProposalPreview;
var completeProposal = ref.completeProposal;
var errorMessage = ref.errorMessage;
var isCompletingProposal = ref.isCompletingProposal;
var fileUploadUrl = ref.fileUploadUrl;
var fileUploadHeaders = ref.fileUploadHeaders;
var proposalFiles = ref.proposalFiles;
var isFileUploading = ref.isFileUploading;
var handleFileUpload = ref.handleFileUpload;
var handleFileDelete = ref.handleFileDelete;
var discountCodes = ref.discountCodes;
var affiliateLink = ref.affiliateLink;
return [_c('proposal-overview-view',{attrs:{"campaign":campaign,"contact":contact,"proposal":proposal,"campaign-fields":campaignFields,"is-proposal-preview":isProposalPreview,"proposal-steps":proposalSteps,"current-proposal-step":currentProposalStep,"is-loading":isLoading,"error-message":errorMessage,"is-completing-proposal":isCompletingProposal,"is-file-uploading":isFileUploading,"proposal-file-props":{
            fileUploadUrl: fileUploadUrl,
            fileUploadHeaders: fileUploadHeaders,
            proposalFiles: proposalFiles,
        },"discount-codes":discountCodes,"affiliate-link":affiliateLink},on:{"complete-proposal":completeProposal,"proposal-file-upload":handleFileUpload,"proposal-file-delete":handleFileDelete}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }